/*
 * Copyright (c) Worldline 2023.
 */

export const CookieKeys = {
    COOKIE_AGREEMENT: 'COOKIE_AGREEMENT',
    JSESSIONID: 'JSESSIONID', // cookie used by tomcat for the session
    NG_TRANSLATE_LANG_KEY: 'NG_TRANSLATE_LANG_KEY' // cookie used to store language selection
}
